<div class="flex flex-wrap">
  <div class="flex " *ngFor="let category of categories;let index=index"
       [class.section-separation]="category.type==='main' && index>0">
    <div [ngClass]=" category.type==='main' ?'categories-chip':'sub-categories-chip'">
      {{category?.name}}
    </div>
  </div>
</div>
